

<template>
  <!-- Product Area Start -->
  <section class="product_area">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-6">
          <div class="product-details-image">
            <img v-bind:src="require(`@/assets/img/${productDetails.img}`)" alt="product"/>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="product-details-text">
            <h3>{{productDetails.title}}</h3>
            <div class="tour-rating">
              <ul>
                <li><i class="fas fa-star"></i></li>
                <li><i class="fas fa-star"></i></li>
                <li><i class="fas fa-star"></i></li>
                <li><i class="fas fa-star"></i></li>
                <li><i class="far fa-star"></i></li>
              </ul>
              <p><a href="javascript:;">({{productDetails.ratings}} customer reviews)</a></p>
            </div>
            <p class="price">
              <del><span class="Price-currencySymbol">£</span>{{productDetails.prevPrice}}</del>
              <ins><span class="Price-currencySymbol">£</span>{{productDetails.price}}</ins>
            </p>
            <div class="pro_details_meta">
              <p>SKU: <span>{{productDetails.sku}}</span></p>
              <p>Category: <span><a href="javascript:;">{{productDetails.catName}}</a></span></p>
              <p>Tag: <span><a href="javascript:;">{{productDetails.tags}}</a></span></p>
            </div>
            <hr>
            <div class="single-pro-page-para">
              <p>{{productDetails.description}}</p>
            </div>
            <div class="pro_choice_meta" v-if="productDetails.crust.length > 0">
              <h4>Select Crust</h4>
              <div class="choice_meta_box">
                <div class="choose_option">
                  <input type="radio" id="dC" name="Crust" value=""/>
                  <label for="dC">Double Crust</label>
                </div>
                <div class="choose_option">
                  <input type="radio" id="sC" name="Crust" value=""/>
                  <label for="sC">Single Crust</label>
                </div>
                <div class="choose_option">
                  <input type="radio" id="tC" name="Crust" value=""/>
                  <label for="tC">Thick Crust</label>
                </div>
                <div class="choose_option">
                  <input type="radio" id="tnC" name="Crust" value=""/>
                  <label for="tnC">Thin Crust</label>
                </div>
              </div>
            </div>
            <div class="pro_choice_meta" v-if="productDetails.size.length > 0">
              <h4>Select Size</h4>
              <div class="choice_meta_box">
                <div class="choose_option">
                  <input type="radio" id="Large" name="size" value=""/>
                  <label for="Large">Large</label>
                </div>
                <div class="choose_option">
                  <input type="radio" id="Medium" name="size" value=""/>
                  <label for="Medium">Medium</label>
                </div>
                <div class="choose_option">
                  <input type="radio" id="Small" name="size" value=""/>
                  <label for="Small">Small</label>
                </div>
              </div>
            </div>
            <div class="quantity">
              <p>Quantity: </p>
              <div class="num-block skin-2">
                <div class="num-in">
                  <span class="minus dis" @click.stop.prevent="quantity--"></span>
                  <input type="text" class="in-num" v-model="quantity" readonly="">
                  <span class="plus" @click.stop.prevent="quantity++"></span>
                </div>
              </div>
            </div>
            <div class="single-shop-page-btn">
              <a href="#" class="cta_btn" @click.stop.prevent="addToCart(productDetails)"><i class="fa fa-shopping-cart"></i> add to cart</a>
              <ul>
                <li>
                  <a href="https://facebook.com" target="_blank">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com" target="_blank">
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.pinterest.com" target="_blank">
                    <i class="fab fa-pinterest-p"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Product Area End -->
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'ProductDetailsArea',
  data() {
    return {
      quantity: 1
    }
  },
  computed: {
    ...mapState({
      productDetails: function (state) {
        const id = Number(this.$route.params.id);
        let products = state.products.items;

        return products.find(item => item.sku === id);
      }
    })
  },
  methods: {
    addToCart(product) {
      let {sku, cat, title, price, img} = product;

      this.$store.dispatch('addToCart', {sku, cat, title, price, img, total: price, quantity: this.quantity})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/ProductDetailsArea.vue